export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const LOGIN_API_KEY = process.env.REACT_APP_LOGIN_API_KEY;
export const SIGNUP_API_KEY = process.env.REACT_APP_SIGNUP_API_KEY;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const DATE_FORMAT = "YYYY-MM-DD";
